import styles from './styles.module.scss';
import NoPromos from '../NoPromos';
import { Table } from 'components-antd';
import Icons from '../../icons';
import PromoActions from '../PromoActions';
import { updatePromotionById } from 'api/promos';
import { showErrorMessage, showSuccessMessage } from 'helpers';

type PromosTablePropsType = {
  active: boolean;
  promos: any[];
  handlePromoClick: Function;
  handlePromoAction: Function;
};

const PromosTable = (props: PromosTablePropsType) => {
  const { active, promos, handlePromoClick, handlePromoAction } = props;

  if (!promos.length) return <NoPromos active={active} />;

  const getFormattedDate = (date: string) => {
    if (!date) return undefined;

    try {
      const splittedDate = date.split(' ')[0].split('-');
      return `${splittedDate[1]}/${splittedDate[2]}/${splittedDate[0]}`;
    } catch (e) {
      return undefined;
    }
  };

  const statusChangeHandler = async (status: boolean, promoId: number) => {
    try {
      const response = await updatePromotionById(promoId, { IsActive: status });
      if (response.status === 200 && response?.data?.result) {
        handlePromoAction(false, response?.data?.result);
        showSuccessMessage(`Promo ${status ? 'activated' : 'deactivated'}`);
      }
    } catch (e) {
      showErrorMessage(`Unable to ${status ? 'activate' : 'deactivate'} promo.`);
    }
  };

  const columns: any[] = [
    {
      title: 'Requestor',
      dataIndex: 'Headline',
      sorter: (a, b) => {
        if (a.Headline < b.Headline) return -1;
        if (a.Headline > b.Headline) return 1;
        return 0;
      },
      render: (_, row) => {
        return (
          <div className={styles.promoHeadline}>
            <div
              className={styles.icon}
              style={{
                backgroundColor: row?.IsActive
                  ? 'rgba(146, 140, 218, 0.08)'
                  : 'rgba(170, 171, 171, 0.08);',
              }}
            >
              <Icons variant={Icons.PROMO} color={active ? '#928CDA' : '#AAABAB'} />
            </div>
            <div className={styles.info}>{row.Headline}</div>
          </div>
        );
      },
    },
    {
      title: 'Start Date',
      dataIndex: 'StartDate',
      width: 175,
      sorter: (a, b) => new Date(a.StartDate).getTime() - new Date(b.StartDate).getTime(),
      render: (_, { StartDate }) => (
        <div className={styles.date}>{getFormattedDate(StartDate) || '—'}</div>
      ),
    },
    {
      title: 'Expiration Date',
      dataIndex: 'ExpirationDate',
      width: 175,
      sorter: (a, b) => new Date(a.ExpirationDate).getTime() - new Date(b.ExpirationDate).getTime(),
      render: (_, { ExpirationDate }) => (
        <div className={styles.date}>{getFormattedDate(ExpirationDate) || '—'}</div>
      ),
    },
    {
      title: '',
      key: 'view',
      width: 100,
      render: (_, row) => {
        return (
          <PromoActions
            promo={row}
            editHandler={handlePromoClick}
            statusChangeHandler={statusChangeHandler}
          />
        );
      },
    },
  ];

  return (
    <div className={styles.promosTable}>
      <Table
        className={styles.table}
        bordered={false}
        columns={columns}
        dataSource={promos.map((item, key) => ({ ...item, key: item.Id }))}
        pagination={false}
      />
    </div>
  );
};

export default PromosTable;
